// Centralised site content — sourced verbatim from the client brief.

export const CONTACT = {
  email: "intolaw@praxio.co.za",
  infoEmail: "info@praxio.co.za",
  whatsappDisplay: "079 485 2928",
  whatsappNumber: "27794852928", // international format for wa.me links
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Contact", to: "/contact" },
  { label: "Terms & Disclosures", to: "/terms" },
];

export const HERO = {
  headline: ["Accessible Legal", "Solutions for Businesses", "and Individuals"],
  subheading:
    "IntoLaw is an independent legal consultancy and a division of Praxio (Pty) Ltd. We help businesses and individuals navigate legal matters with confidence through affordable legal consulting, compliance solutions, document drafting and dispute-resolution support.",
};

export const BUSINESS_SERVICES = {
  title: "Corporate & Commercial Solutions",
  intro:
    "We help startups, entrepreneurs, SMEs and established businesses build legally compliant organisations and minimise commercial risk.",
  items: [
    {
      title: "Contract Drafting & Management",
      body: "Preparation of customised Independent Contractor Agreements, Non-Disclosure Agreements (NDAs), Service Level Agreements (SLAs), Employment Agreements, Website Terms and Conditions and other commercial contracts.",
      icon: "FileSignature",
    },
    {
      title: "Corporate Governance & CIPC Compliance",
      body: "Preparation of Shareholders' Agreements, Memoranda of Incorporation (MOIs), governance documentation, company resolutions and investor-readiness documentation.",
      icon: "Building2",
    },
    {
      title: "POPIA Compliance",
      body: "POPIA compliance assessments, privacy documentation, internal policies, data-processing guidance and risk mitigation.",
      icon: "ShieldCheck",
    },
    {
      title: "Labour Relations & Workplace Policies",
      body: "Preparation of employment contracts, disciplinary procedures, workplace policies, social media policies, codes of conduct and employer guidance.",
      icon: "Users",
    },
  ],
};

export const PERSONAL_SERVICES = {
  title: "Personal & Consumer Legal Support",
  intro:
    "We assist individuals in protecting their legal rights through practical consulting and document preparation.",
  items: [
    {
      title: "Litigation Support",
      body: "Practical guidance and document preparation support for self-represented litigants navigating court procedures.",
      icon: "Scale",
    },
    {
      title: "Residential Lease & Tenant Consulting",
      body: "Lease agreement drafting, lease reviews and preparation of formal letters relating to landlord and tenant disputes.",
      icon: "Home",
    },
    {
      title: "Employment & CCMA Guidance",
      body: "Employment contract reviews, BCEA guidance and preparation support for CCMA referrals.",
      icon: "Briefcase",
    },
    {
      title: "Consumer Protection",
      body: "Preparation of Consumer Protection Act (CPA) letters of demand and assistance with complaints to the National Consumer Commission and recognised industry ombuds.",
      icon: "BadgeCheck",
    },
    {
      title: "Deceased Estates & Simple Wills",
      body: "Preparation of Last Wills and Testaments and consulting relating to administrative processes involving smaller deceased estates.",
      icon: "ScrollText",
    },
    {
      title: "Private Mediation",
      body: "Independent mediation services aimed at helping parties resolve disputes amicably and prepare settlement agreements or parenting plans where appropriate.",
      icon: "Handshake",
    },
  ],
};

export const WHY_CHOOSE = [
  {
    title: "Fixed & Transparent Pricing",
    body: "Know exactly what you will pay before work begins.",
  },
  {
    title: "Affordable Professional Assistance",
    body: "Access practical legal consulting without traditional hourly legal fees.",
  },
  {
    title: "Plain Language",
    body: "We explain legal matters in clear language that clients can understand.",
  },
  {
    title: "Preventative Legal Approach",
    body: "We focus on helping clients prevent disputes before they arise.",
  },
  {
    title: "Business-Focused Solutions",
    body: "We assist businesses in reducing legal and compliance risk while supporting sustainable growth.",
  },
];

export const ABOUT = {
  intro:
    "IntoLaw is a premier independent legal consultancy in South Africa dedicated to bridging the gap between complex legal frameworks and everyday realities.",
  paragraphs: [
    "We specialise in non-litigious legal consulting, regulatory compliance, document drafting and dispute-resolution preparation.",
    "Traditional legal fees often place quality legal assistance beyond the reach of many entrepreneurs, small businesses and individuals. IntoLaw was established to provide practical, affordable and high-value legal consulting services with transparent fixed pricing.",
    "We empower entrepreneurs to build compliant businesses, protect their commercial interests and minimise legal risk. We also help individuals safeguard their personal, financial and consumer rights through practical legal guidance.",
  ],
  vision:
    "To become South Africa's most trusted and accessible independent legal consultancy, recognised for clarity, affordability, professionalism and practical legal solutions.",
  mission:
    "To deliver high-quality, affordable legal consulting, compliance solutions and legal documentation that protect the commercial and personal interests of our clients without the traditional law firm price tag.",
  disclaimer: [
    "IntoLaw is an independent legal consultancy and a division of Praxio (Pty) Ltd.",
    "We are not a law firm.",
    "We do not practise as registered attorneys or advocates.",
    "We do not provide formal court representation.",
    "We do not maintain a Legal Practice Council trust account.",
    "Our services focus on specialised legal consulting, document drafting, compliance, contract management and dispute-resolution preparation.",
  ],
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1623177623442-979c1e42c255?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxsYXclMjBvZmZpY2UlMjBwcmVtaXVtJTIwYXJjaGl0ZWN0dXJlJTIwZGVza3xlbnwwfHx8fDE3ODI3MjczOTh8MA&ixlib=rb-4.1.0&q=85",
  about:
    "https://images.pexels.com/photos/5673472/pexels-photo-5673472.jpeg",
  brass:
    "https://images.unsplash.com/photo-1559058922-5d29e1f00075?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGdlb21ldHJpYyUyMGdvbGQlMjBsZWdhbCUyMHNjYWxlfGVufDB8fHx8MTc4Mzg3NDc2Mnww&ixlib=rb-4.1.0&q=85",
  goldStripes:
    "https://images.unsplash.com/photo-1628331507643-ddf8016ca45d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGdlb21ldHJpYyUyMGdvbGQlMjBsZWdhbCUyMHNjYWxlfGVufDB8fHx8MTc4Mzg3NDc2Mnww&ixlib=rb-4.1.0&q=85",
};
